// extracted by mini-css-extract-plugin
export var box = "Container-module--box--b9da5";
export var box_md = "Container-module--box_md--fbd3f";
export var box_xmd = "Container-module--box_xmd--bc4c6";
export var box_flex = "Container-module--box_flex--b4059";
export var box_lg = "Container-module--box_lg--12283";
export var box_sm = "Container-module--box_sm--979b2";
export var box_outer = "Container-module--box_outer--971cf";
export var box_whiteBg = "Container-module--box_white-bg--2c4b9";
export var box_noMarginBottom = "Container-module--box_no-margin-bottom--43b5a";
export var box_noPadding = "Container-module--box_no-padding--6dd91";
export var box_outerGray = "Container-module--box_outer-gray--492c7";
export var box_dark = "Container-module--box_dark--750e6";
export var box_zIndex = "Container-module--box_z-index--fa105";
export var box_zIndex6 = "Container-module--box_z-index-6--66868";
export var box_eventsWithLine = "Container-module--box_events-with-line--dbc3d";
export var box_featuresAo = "Container-module--box_features-ao--961d5";
export var box_verticalPaddings = "Container-module--box_vertical-paddings--8a32e";
export var clearP = "Container-module--clearP--28a0a";
export var clearP_vc = "Container-module--clearP_vc--d148b";
export var container = "Container-module--container--687df";
export var marginTop = "Container-module--marginTop--96c8f";
export var paddingTopWithoutBottom = "Container-module--paddingTopWithoutBottom--f0630";
export var paddingTopWithBottom = "Container-module--paddingTopWithBottom--10be2";
export var marginNone = "Container-module--marginNone--4b528";
export var outer = "Container-module--outer--53b12";
export var inner = "Container-module--inner--c1cf4";
export var paddingWithout = "Container-module--paddingWithout--3d5aa";
export var paddingXL = "Container-module--paddingXL--c7983";
export var paddingVertical = "Container-module--paddingVertical--24f08";
export var paddingHorizontal = "Container-module--paddingHorizontal--337d4";
export var paddingBottomNone = "Container-module--paddingBottomNone--53b9c";
export var paddingTopNone = "Container-module--paddingTopNone--cbecc";
export var whiteBG = "Container-module--whiteBG--9f44a";
export var transparentBG = "Container-module--transparentBG--79355";
export var transparent02BG = "Container-module--transparent02BG--1dfcd";
export var grayBG = "Container-module--grayBG--31aa0";
export var lightGrayBG = "Container-module--lightGrayBG--dfc72";
export var smokyBG = "Container-module--smokyBG--8e7a8";
export var darkPrimaryBG = "Container-module--darkPrimaryBG--5a37e";
export var fadeInAnimation = "Container-module--fadeInAnimation--00594";
export var placeHolderShimmer = "Container-module--placeHolderShimmer--b1127";